export default {
  title: 'Tuotteet',
  order_note: 'Tilausmuistiinpano',
};
